type FilterButtonProps = {
	label: string;
	disabled?: boolean;
	isActive?: boolean;
	onClick: () => void;
	ariaLabel: string;
};

export default function FilterButton(props: FilterButtonProps) {
	const { ariaLabel, label, disabled = false, isActive = false, onClick } = props;

	const classes = ['glossary__filter-button'];
	if (isActive) {
		classes.push('glossary__filter-button--active');
	}

	return (
		<button type="button" className={classes.join(' ')} disabled={disabled} onClick={onClick} aria-pressed={isActive} aria-label={ariaLabel}>
			{label}
		</button>
	);
}
